<template>
  <router-view />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Index",
  props: ["subdomain", "uuid"],
  computed: {
    ...mapGetters("merchantToken", ["merchantToken"]),
    ...mapGetters("survey", ["surveyDetails"]),
  },
  methods: {
    ...mapActions("merchantToken", ["getMerchantToken"]),
    ...mapActions("survey", ["getSurveyDetails", "getSurveyDesign"]),
  },
  created() {
    this.getMerchantToken(this.subdomain).then(() => {
      if (!this.merchantToken) {
        this.$router.push({ name: "NotFound" });

        return;
      }

      Promise.all([
        this.getSurveyDetails(this.uuid),
        this.getSurveyDesign(this.uuid),
      ]).then(() => {
        if (this.surveyDetails) {
          if (!this.surveyDetails.is_enabled) {
            this.$router.push({ name: "NotFound" });

            return;
          }

          if (this.surveyDetails.expired) {
            this.$router.push({ name: "NotAvailable" });

            return;
          }

          if (this.surveyDetails.pages.length) {
            this.surveyDetails.pages.map((page) => {
              if (!page.questions.length) {
                this.$router.push({ name: "NotFound" });

                return;
              }
            });
          } else {
            this.$router.push({ name: "NotFound" });

            return;
          }
        } else this.$router.push({ name: "NotFound" });
      });
    });
  },
};
</script>

<style>
</style>